import { render } from "./OrderFlags.vue?vue&type=template&id=71013311&scoped=true"
import script from "./OrderFlags.vue?vue&type=script&lang=js"
export * from "./OrderFlags.vue?vue&type=script&lang=js"

import "./OrderFlags.vue?vue&type=style&index=0&id=71013311&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71013311"]])

export default __exports__